import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // console.log("Sort form controller connected")
  }
  
  submit(event) {
    event.preventDefault()
    
    // Get the selected sort option
    const sortOption = event.target.value
    
    // Get existing URL parameters (for filters)
    const url = new URL(window.location.href)
    const params = new URLSearchParams(url.search)
    
    // Remove all sort parameters
    const sortParams = ["latest", "price_asc", "price_desc", "name_asc", "name_desc"]
    sortParams.forEach(param => {
      params.delete(param)
    })
    
    // Remove sort_options parameter (not needed)
    params.delete('sort_options')
    
    // Add the selected sort parameter
    params.set(sortOption, 'true')
    
    // Navigate using Turbo for SPA-like experience
    Turbo.visit(`${url.pathname}?${params.toString()}`, { 
      action: 'replace',
      frame: 'products_list'
    })
  }
} 
